import { combineReducers } from 'redux';

import {
  createApiReducer,
  chainReducers,
} from 'services/api';

import { AuthActionTypes } from 'services/auth/redux/actions';


import { ActiveUserState } from './types';
import { UsersActionTypes } from './actions';
import { transformActiveUser } from 'services/api/users/transformations';






// ACTIVE USER REDUCER

const initialState: ActiveUserState = {
  // currencyCode: null,
  // environment: null,
  // tenant: null,
  user: null,
  // userGlobalId: null,
  // _status: INITIAL_API_STATUS,
  // permissions: [],
  // isAdmin: false,
  // externalAccountId: null,
  // externalContactId: null,
  // isExecutor: false,
  // maxIntegrations: null,
};

const signInReducer = createApiReducer(
  [
    AuthActionTypes.SIGN_IN_START,
    AuthActionTypes.SIGN_IN_SUCCESS,
    AuthActionTypes.SIGN_IN_FAILURE,
  ],
  (_data: any, state: any) => ({ user: state?.user ?? null }),
  data => data
);

const fetchCurrentUserReducer = createApiReducer(
  [
    UsersActionTypes.FETCH_ACTIVE_USER_START,
    UsersActionTypes.FETCH_ACTIVE_USER_SUCCESS,
    UsersActionTypes.FETCH_ACTIVE_USER_FAILURE,
  ],
  transformActiveUser,
  data => data
);

const signOutReducer = createApiReducer(
  ['', AuthActionTypes.SIGN_OUT, ''],
  () => initialState,
  () => initialState
);

const activeUserReducer = chainReducers(
  initialState,
  signInReducer,
  fetchCurrentUserReducer,
  signOutReducer
);

// COMBINED REDUCER

export default combineReducers({
  activeUser: activeUserReducer,
});
